import React, { useEffect, useState } from "react";
import { List, Typography } from "antd";
import styles from "./Message.module.css";
import profileImage from "../../assets/profile1.png";
import profileImage2 from "../../assets/profile2.png";
import ArrowIcon from "../../assets/arrow.png";
import LinkIcon from "../../assets/link.png";
import { useDispatch, useSelector } from "react-redux";
import ChatMiddleware from "../../store/Middlewares/ChatMiddleware";
import ChatMessage from "../../components/chatMessage/ChatMessage";

const Message = (data) => {
  const Data = data?.data?.state?.data

  const dispatch = useDispatch()
  const [ChatData, setChatData] = useState(null)
  const user = useSelector((state) => state.AuthReducer.user)
  const [userDetails, setuserdetails] = useState(null)

  const { Text } = Typography;

  useEffect(() => {
    chatlistCheck()
  }, [])



  console.log('ChatData', ChatData)
  const chatlistCheck = () => {
    dispatch(ChatMiddleware.chatlistCheck(Data?.cleaner_id))
      .then((data) => {
       
        setChatData(data?.data)
      })
      .catch((err) => console.log(err))
  }
 

  return (
    <div>
      {ChatData ? <ChatMessage data={ChatData} /> : null}
    </div>
    
  );
};

export default Message;
